import { combineReducers } from 'redux';
import evaluateReducer from './evaluateReducer';
import homeReducer from './homeReducer';
import appointEditReducer from './appointEditReducer';
import appointmentDateChangeReducer from './appointmentDateChangeReducer';
import serviceAppointmentReducer from './serviceAppointmentReducer';
import {reducer as formReducer} from 'redux-form';

const combineRed = combineReducers({
    homeReducer,
    evaluateReducer,
    appointEditReducer,
    appointmentDateChangeReducer,
    serviceAppointmentReducer,
    form: formReducer,
});

export default combineRed